import SvgIcon from '@material-ui/core/SvgIcon';

function StatusDone(props) {
  return (
    <SvgIcon width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
      <circle cx="24" cy="24" r="23" stroke="#00BB7E" strokeWidth="2" />
      <path d="M17 24L21.5 28.5L31.5 18.5" stroke="#00BB7E" strokeWidth="2" />
    </SvgIcon>
  );
}

export default StatusDone;
